import {twMerge} from "tailwind-merge"
import {
  FilterBorderColors,
  FilterIconColors,
  FilterIcons,
  OptionTypes,
} from "@/components/archive/Filtering/utils"

interface FilterIndicatorProps {
  type: OptionTypes
  label?: string
  text?: string
  containerClass?: string
}

const FilterIndicator = ({
  type,
  label,
  text,
  containerClass,
}: FilterIndicatorProps) => {
  return (
    // </Tooltip>
    <div
      className={twMerge(
        `flex w-fit flex-row items-center gap-1 rounded-full border-2 bg-white p-1 px-2`,
        FilterBorderColors[type],
        containerClass
      )}
    >
      <div
        className={twMerge(
          "flex flex-row items-center gap-2",
          FilterBorderColors[type],
          FilterIconColors[type]
        )}
      >
        {FilterIcons[type]}
      </div>
      <div className="flex flex-row items-center gap-2">
        {label && <p className="text-sm font-medium">{label}</p>}
        {text && <p className="font-regular text-xs">{text}</p>}
      </div>
    </div>
  )
}

export default FilterIndicator
